import { put, call, select } from 'redux-saga/effects'

import { ERROR_TYPE_NOT_FOUND } from '../../../../../helpers/const'
import { renderSplash } from '../../../../../splash/index'
import { fetchFlyerGib } from '../../../../../api/products/fetchFlyerGib'
import manipulateProducts from '../../../../manipulators/2.0/products'
import { appendProducts } from '../../../../actions/products'
import { setIsCampaignExpired } from '../../../../actions/ux'
import { selectFeedTotalCount } from '../../../../selectors/feed'
import { selectLabel } from '../../../../selectors/i18n'
import { selectCurrentTheme } from '../../../../selectors/ux'
import getManipulationContext from './getManipulationContext'

/*
  Feed mode safety net: an in-session navigation may point to a product
  living in a page not yet loaded. Fetch the single gib and cache it.
  Missing or expired gib -> NOT_FOUND splash, mirroring validateProduct.
*/
function* getFlyerGib(action) {
  const { flyerId, gibId, country } = action.payload

  let products = {}
  try {
    const gib = yield call(fetchFlyerGib, { country, flyerId, gibId })
    const totalCount = yield select(selectFeedTotalCount)
    const { currentDate, isPreview, favouriteProductIds } = getManipulationContext()
    const manipulated = manipulateProducts(
      gib ? [gib] : [],
      currentDate,
      isPreview,
      favouriteProductIds,
      totalCount || 0,
    )
    products = manipulated.products
  } catch (error) { console.error(error) } // eslint-disable-line no-console

  if (products[gibId]) {
    yield put(appendProducts(products))
    return
  }

  const theme = yield select(selectCurrentTheme)
  const productNotFound = yield select(selectLabel('productNotFound'))
  yield put(setIsCampaignExpired(true))
  renderSplash({
    type: ERROR_TYPE_NOT_FOUND,
    message: productNotFound,
    error: 'Product not found',
    theme,
  })
}

export default getFlyerGib
